import React from 'react';
import styles from '../../styles/Building MGMT/MiniUnitCard.module.css';

const MiniUnitCard = ({ unit, onSelect }) => {
  return (
    <div className={styles.card} onClick={() => onSelect(unit)}>
      <h4 className={styles.unitNumber}>🏠 Unit #{unit.number}</h4>
      <p className={styles.details}>
        🛏️ {unit.beds} Bd · 🛁 {unit.baths} Ba
      </p>
	  <p className={styles.details}>
	  📏 {unit.sqft} SqFt
	  </p>
    </div>
  );
};

export default MiniUnitCard;
